import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

const router = new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'index',
    //   component: () => import('@/views/Home/index.vue'),
    //   meta: {
    //     title: 'Okawa-HomePage!'
    //   }
    // },
    {
      path: '/',
      name: 'index',
      redirect: '/okawa-app'
    },
    {
      path: '/okawa-app',
      name: 'okawa-app',
      component: () => import('@/views/OkawaApp/index-pc-en.vue'),
      meta: {
        title: '大川电机',
        icon: "./assets/favicon.ico"
      }
    },
    {
      path: '/appInstructions-pc-en',
      name: 'appInstructions-pc-en',
      component: () => import('@/views/AppInstructions/index-pc-en.vue'),
      meta: {
        title: 'App-PC-Instructions!'
      }
    },
    {
      path: '/appInstructions-m-cn/:type',
      name: 'appInstructions-m-cn',
      component: () => import('@/views/AppInstructions/index-mobile-cn.vue'),
      meta: {
        title: 'App-M-操作手册!'
      }
    },
    {
      path: '/appInstructions-m-en/:type',
      name: 'appInstructions-m-en',
      component: () => import('@/views/AppInstructions/index-mobile-en.vue'),
      meta: {
        title: 'App-M-Instructions!'
      }
    },
    {
      path: '/userAgreementCn',
      name: 'userAgreementCn',
      component: () => import('@/views/Agreement/index-cn.vue'),
      meta: {
        title: 'Okawa AESM 用户协议'
      }
    },
    {
      path: '/userAgreementEn',
      name: 'userAgreementEn',
      component: () => import('@/views/Agreement/index-en.vue'),
      meta: {
        title: 'Okawa AESM User agreement'
      }
    },
    {
      path: '/privacyPolicyCn',
      name: 'privacyPolicyCn',
      component: () => import('@/views/Policy/index-cn.vue'),
      meta: {
        title: 'Okawa AESM 隐私政策'
      }
    },
    {
      path: '/privacyPolicyEn',
      name: 'privacyPolicyEn',
      component: () => import('@/views/Policy/index-en.vue'),
      meta: {
        title: 'Okawa AESM Privacy policy'
      }
    },
    {
      path: '/privacyPolicyEurope',
      name: 'privacyPolicyEurope',
      component: () => import('@/views/Policy/index-europe.vue'),
      meta: {
        title: 'OKAWA Mobile Application Privacy Policy'
      }
    },
    {
      path: '/maintenanceVideo',
      name: 'maintenanceVideo',
      component: () => import('@/views/MaintenanceVideo/index.vue'),
      meta: {
        title: 'Okawa AESM Maintenance Video'
      }
    },{
      path: '/videoPlayer',
      name: 'videoPlayer',
      component: () => import('@/views/VideoPlayer/index.vue'),
      meta: {
        title: 'Okawa AESM Maintenance Video'
      }
    },{
      path: '/applyAccountCancellation',
      name: 'applyAccountCancellation',
      component: () => import('@/views/AccountCancellation/index.vue'),
      meta: {
        title: 'Okawa Account Cancellation'
      }
    }
  ]
})

router.beforeEach((to,from,next)=>{
  if(to.meta.title){
      document.title = to.meta.title
  }

  // if(to.meta.icon){
  //   let node = document.createElement('link')
  //   node.rel = 'icon'
  //   node.href = to.meta.icon
  //   document.head.appendChild(node)
  // }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js